module.exports = __webpack_public_path__ + "static/img/111-1.6a899d41.png";